export function removeBlobImageFromActiveTinyMceEditor() {
  const img = tinymce.activeEditor.dom.doc.querySelector('img[src^="blob:"]');

  if (img) {
    tinymce.activeEditor.execCommand('mceRemoveNode', false, img);
  }
}
